import * as React from 'react'
import { useRecoilState, useRecoilValue } from 'recoil'
import { RadioButton } from 'react-native-paper'
import { serviceOrdersFiltersState, statusOSsState } from '@/presentation/pages/ServiceOrders/components'
import { useMediaQueries, useThemeClient } from '@/presentation/hooks'

export const SelectStatusOsFilter = (): JSX.Element => {
  const { getThemeClient } = useThemeClient()
  const { isMobile } = useMediaQueries()
  const [filters, setFilters] = useRecoilState(serviceOrdersFiltersState)
  const statusOSs = useRecoilValue(statusOSsState)

  const themeClient = getThemeClient()

  const handleOnSelect = (selectedStatus: 'Em Aberto' | 'Fechadas' | 'Todas'): void => {
    setFilters((currentFilters) => ({ ...currentFilters, situacao: selectedStatus }))
  }

  return (
    <>
      {
        statusOSs.map((statusOption) => (
          <RadioButton.Item
            key={statusOption._id}
            label={statusOption.value}
            value={statusOption.value}
            status={filters.situacao === statusOption.value ? 'checked' : 'unchecked'}
            onPress={() => handleOnSelect(statusOption.value as 'Em Aberto' | 'Fechadas' | 'Todas')}
            labelStyle={{ fontSize: isMobile ? 14 : 16 }}
            style={{
              borderRadius: 4,
              borderWidth: 1,
              borderColor: `${themeClient.mainColor}26`,
              marginBottom: 8,
              paddingVertical: isMobile ? 0 : 16
            }}
            color={themeClient.mainColor}
          />
        ))
      }
    </>
  )
}
